import { Box } from "@element-plus/icons";

export default{
    agroServe:{
        Description:{
            title1:'国家级保真保质服务',
            title2:'企业数字化集成应用服务',
            title3:'产地政府数字化服务',
            module1:{
                title:'检测认证提优，全球互认优价，保供全程安心',
                text:'国家级保真保质支撑体系（质量标准中心、质量检测中心、品质评价中心），提供国家级标准、检测和品质评价服务，实现全球“产销检测互认”、“食安和高质量保供”、全球“产销融互见”及“优质优价”！',
                box1:{
                    title:'标准中心',
                    text:'提供农业全产业链标准制定、贯彻、反馈与优化服务，提高农业生产效率和产品质量。'
                },
                box2:{
                    title:'检测中心',
                    text:'提供全面、精准的检测服务，涵盖蔬菜、水果、水产、畜牧等各类产品。'
                },
                box3:{
                    title:'品质评价中心',
                    text:'挖掘每一份农产品的独特品质、口感、风味，用科学定义好吃、用数据呈现美味!'
                },
                btn:'查看详情'
            },
            module2:{
                imgBox1:{
                    imgT1:'农业企业数字化集成应用平台',
                    imgT2:'连接未来农业，实现高效精准管理',
                    text:'企业可通过货源登记、种植养殖数字化管理、品质控制、溯源服务和产品上架等模块，实现供应链管理、生产监控、质量保障、溯源透明和销售优化。平台以数据驱动和全流程透明化，助力提升生产效率和产品质量。'
                },
                imgBox2:{
                    imgT1:'政府产业运营应用平台',
                    imgT2:'智联产业生态，赋能高效运营与可持续发展',
                    text:'可利用产业大数据和网格化监管强化行业监控，通过质量合格证明、采样及检测管理提升产品质量管控，依托产业运营服务优化资源配置。平台助力政府搭建高效监管与服务平台，推动产业健康发展，增强区域产业竞争力。'
                },
                btn:'进入平台'
            }
        }
    }
}